<template>
  <div id="app">
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
      <router-link v-bind:to="'/dashboard'" class="navbar-brand col-sm-3 col-md-2 mr-0">Price monitor</router-link>
      <!--input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search"-->
      <ul class="navbar-nav px-3">
        <li class="nav-item text-nowrap">
            <a class="nav-link" href="#" @click="logout" v-if="username">Esci</a>
            <router-link v-bind:to="'/login'" class="nav-link" v-if="!username">Entra</router-link>
        </li>
      </ul>
    </nav>

    <div class="container-fluid">
      <div class="row d-block">
        <nav class="col-md-2 d-none d-md-block bg-light sidebar" v-if="username">
          <div class="sidebar-sticky">
            <ul class="nav flex-column">
              <li class="nav-item">
                <a class="nav-link">
                  <feather-icon type="home" class="feather-icon"></feather-icon>
                  <router-link v-bind:to="'/dashboard'">Dashboard</router-link>
                </a>
              </li>
              <li class="nav-item">
                  <a class="nav-link">
                    <feather-icon type="pie-chart" class="feather-icon"></feather-icon>
                    <router-link v-bind:to="'/reports'">Reports</router-link>
                  </a>
              </li>
              <li class="nav-item">
                  <a class="nav-link">
                    <feather-icon type="tag" class="feather-icon"></feather-icon>
                    <router-link v-bind:to="'/products'">Prodotti</router-link>
                  </a>
              </li>
              <li class="nav-item">
                  <a class="nav-link">
                    <feather-icon type="compass" class="feather-icon"></feather-icon>
                    <router-link v-bind:to="'/websites'">Siti</router-link>
                  </a>
              </li>
              <!--li class="nav-item">
                  <a class="nav-link">
                    <feather-icon type="edit" class="feather-icon"></feather-icon>
                    <router-link v-bind:to="'/integrations'">Integrazioni</router-link>
                  </a>
              </li-->
            </ul>
          </div>
        </nav>
        <main role="main" class="px-4" v-bind:class="{ 'col-md-10': username, 'col-xs-12': (!username), 'ml-sm-auto': username }">
          <router-view @loggedin="loadData"/>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      username: '',
      jwt: ''
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
        this.username = localStorage.getItem('username')
        this.jwt = localStorage.getItem('jwt')
    },
    async logout () {
      localStorage.removeItem('username')
      localStorage.removeItem('jwt')
      this.$router.push('/login')
      this.loadData()
    }
  }
}
</script>

<style>
body {
    margin:0;
}
.menu {
    margin-bottom: 60px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}

body {
  font-size: .875rem;
}

.feather-icon {
    stroke:#4d7ef7!important;
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
}
svg {
    stroke:#4d7ef7!important;
}
circle {
    stroke:#4d7ef7!important;
}
path {
    stroke:#4d7ef7!important;
}
polygon {
    stroke:#4d7ef7!important;
}

main {
    text-align: center;
}

/*
 * Sidebar
 */

.sidebar {
  position: fixed!important;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100; /* Behind the navbar */
  padding: 48px 0 0; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

.sidebar-sticky {
  position: relative!important;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}

/*
 * Content
 */

[role="main"] {
  padding-top: 133px; /* Space for fixed navbar */
}

@media (min-width: 768px) {
  [role="main"] {
    padding-top: 72px; /* Space for fixed navbar */
  }
}

/*
 * Navbar
 */

.navbar-brand {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: 1rem;
  background-color: rgba(0, 0, 0, .25);
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
}

.navbar .form-control {
  padding: .75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, .1);
  border-color: rgba(255, 255, 255, .1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
}
</style>



// WEBPACK FOOTER //
// src/App.vue